export enum eSaleStatus {
	PENDING_PAYMENT = 1,
	APPROVED_PAYMENT = 2,
	PENDING_SHIPPING = 10,
	SHIPPING_DATE_SET = 15,
	IN_PROGRESS_DELIVERY = 20,
	RECEIVED = 30,
	FAILED = 80,
	CANCELED = 90
}